import http from "@/utils/request"

export default {
  getSetting: {
    url: '/common/getSetting',
    name: "获取设置",
    post: async function(params){
      return await http.get(this.url, params);
    }
  }
}